import { render, staticRenderFns } from "./formChangeMailNew.vue?vue&type=template&id=0b2937ba&"
import script from "./formChangeMailNew.vue?vue&type=script&lang=js&"
export * from "./formChangeMailNew.vue?vue&type=script&lang=js&"
import style0 from "./formChangeMailNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports